<template>
    <div class="tempVotDash">

        <div class="titleDashboard ">

            BEWERTUNGSRADAR

        </div>

        <div class="drpDownDark">
            <div class="longTitle">
                Bitte wählen Sie eine Bewertungsrunde aus:
            </div>
            <div>
                <DxSelectBox :data-source="ratingTypeGroupSimpleList"
                             :show-clear-button="true"
                             display-expr="RtgName"
                             value-expr="RtgId"
                             v-model:value="rtgId">
                </DxSelectBox>
            </div>
        </div>
        <div class="staGrid">

            <div>
             
            </div>


            <div class="staBox">

                <voting-stats></voting-stats>
            </div>

            <div class="staSpider">
                <spider-web></spider-web>
            </div>

            <div class="pieDash">
                <div>
                    <pie-chart rtgId="9"></pie-chart>

                </div>
                <div>
                    <pie-chart-steep rtgId="9" lisId="77" atrId="506"></pie-chart-steep>

                </div>
            </div>
            <!--<div>
            <DxButton :width="141"
                      class="tsBtnDx"
                      @click="onCancelClick($event)">
                <i class="dx-icon fa fa-arrow-circle-left"></i>
                <span class="dx-button-text">
                    Zurück zur Übersicht
                </span>
            </DxButton>
        </div>-->
        </div>

    </div>
</template>
<script>
    import votingStats from './widgets/statistics/votingStats.vue'
    import spiderWeb from './widgets/statistics/spiderWeb.vue'
    import pieChart from './widgets/statistics/pieChart.vue'
    import pieChartSteep from './widgets/statistics/pieChartSteep.vue'
    import { DxSelectBox } from 'devextreme-vue/select-box';
    /*   import { DxButton } from 'devextreme-vue/button'*/
    import $ from 'jquery';
    //import { computed } from 'vue';
    export default {
        name: 'DashboardVotingVx',
        components: {
            votingStats,
            spiderWeb,
            pieChart,
            pieChartSteep,
            /*DxButton*/
            DxSelectBox
        },
        data() {

            return {
                selectedRouId: null,
            
            }
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=return").submit()
            },
        },
        computed: {
            ratingTypeGroupSimpleList() {
                var result = this.$store.state.ratingTypeGroupStore.ratingTypeGroupSimpleList
                return result
            },
            rtgId: {
                get: function () {
                    return window.State.getRtgId()
                },
                set: function (newValue) {
                    window.State.setRtgId(newValue);
                }

            }
        },
      
        mounted: function () {
            this.$store.dispatch("getRatingTypeGroupSimpleList", {})
        }
    }
</script>
<style scoped>
    span {
        font-size: 15px;
        font-family: var(--font-family);
    }

    div {
        font-size: 15px;
    }

  
    .staGrid {
        color: white;
        grid-template-columns: 50% 50%;
        gap: 20px;
        /*  margin-top: 30px;*/

        display: inline-flex;
        flex-direction: column;
        align-content: flex-start;
    }

    div.staBox {
        max-width: 50%
    }

    ul {
        list-style-type: none
    }

    h1 {
        color: #717c86;
    }

    .longTitle {
        color: whitesmoke
    }

    .tsBtnDx {
        width: 120px;
        background-color: var(--danger-color);
        margin-bottom: 30px;
        margin-top: 30px;
        padding: 1px 2px 2px 2px;
    }

    .pieDash {
        display: flex;
        flex-direction: row;
        width: 1000px;
    }

    .titleDashboard {
        font-weight: bold;
        color: #f4c543;
        font-family: var(--font-family);
        font-size: 35px;
    }

    .tempVotDash {
        padding-left: 40px;
        padding-top: 20px;
    }
    .drpDownDark {
        display: inline-grid;
        flex-wrap: wrap;
        gap: 12px;
        padding-bottom:20px;
    }




    .bitv .longTitle, .bitv .staGrid, .bitv .h1, .bitv .textWlc, .bitv .tableTextWlc, .bitv .iconSource > i, .bitv .iconTable > i {
        color: black;
    }

    .bitv .tsBtnDx {
        color: black;
        background: none;
        border: solid 1px;
        font-weight: bold;
    }


</style>